import {FC, MutableRefObject} from 'react'
import { getStyledNavIcon } from '../../styled-components/NavBar.styled'

export interface NavBarIconProps {
    icon: JSX.Element,
    text: string,
    refItem: MutableRefObject<any>,
    action: (itemRef: MutableRefObject<any>) => void
}

export const NavBarIcon: FC<NavBarIconProps> = ({icon, text, action, refItem}) => {

    const StyledNavIcon = getStyledNavIcon()

    return(
        <StyledNavIcon 
            onClick={() => {
                action(refItem)
            }}
        >
            {icon}
            <span>{text}</span>
        </StyledNavIcon>
    )
}